import {
  type BasePageParams,
  getPageUrl,
  getUrlRegion,
} from '@/app/urls/url-mapping';
import { type Language } from '@/lib/utils/language';
import { type Region } from '@/types';

// DatoCMS template links still use https://example.com in some records.
export const replacePlaceholderLink = (
  link: string,
  locale: Pick<BasePageParams, 'language' | 'region'>
): string => {
  const isPlaceholder = (): boolean => {
    try {
      const { hostname } = new URL(link);
      return hostname.endsWith('example.com');
    } catch {
      return link.includes('example.com');
    }
  };

  if (!isPlaceholder()) return link;

  return getPageUrl('home', locale) ?? link;
};

// Maybe this function isn't really needed anymore...
export const getArticleHref = (previewUrl: string): string => {
  const match = previewUrl.match(/\/([a-z]{2})\/([a-z]{2})\/blog\/(.*)/u);
  if (!match) return previewUrl;

  const [, region, language, slug] = match as [
    unknown,
    Region,
    Language,
    string
  ];

  return getPageUrl('blogArticle', { language, region, slug }) ?? previewUrl;
};

// To avoid updating every single URL on Dato to URL regions, this function
// converts the old region/language URLs to URL regions.
export const updateUrlRegion = (path: string): string => {
  const url = new URL(path, 'https://example.org');
  const regionLanguageRegex =
    /^\/(br|de|es|fr|mx|nl|pt|uk|us|ww)\/(de|en|es|fr|nl|pt)(\/|$)/u;
  const match = url.pathname.match(regionLanguageRegex);
  if (!match) return path;

  const [, region, language] = match as [unknown, Region, Language];
  const urlRegion = getUrlRegion({ language, region });
  const rest = url.pathname.replace(`/${region}/${language}`, '');
  url.pathname = `/${urlRegion}${rest}`;
  return url.href.replace('https://example.org', '');
};

export const getScrollBehavior = (): ScrollBehavior =>
  window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ? 'auto'
    : 'smooth';
